import React, { useState } from 'react';

interface Props extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src'> {
  // Asset slot key from the backend (e.g. "home.entryAnimation").
  assetKey: string;
  // Bundled image to show until a file has been uploaded for the slot
  // (the API returns 404 for empty slots) or when the API is down.
  fallbackSrc: string;
}

// An image whose file can be replaced from the admin center's Media tab.
function SiteAssetImage({ assetKey, fallbackSrc, alt, ...rest }: Props): JSX.Element {
  const [failed, setFailed] = useState(false);
  return (
    <img
      src={failed ? fallbackSrc : `/api/assets/${encodeURIComponent(assetKey)}`}
      onError={() => setFailed(true)}
      alt={alt}
      {...rest}
    />
  );
}

export default SiteAssetImage;
